import { useEffect } from 'react';

const SITE_URL = process.env.REACT_APP_SITE_URL;

const setTag = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(attrs.tag);
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => {
    if (k !== 'tag' && v != null) el.setAttribute(k, v);
  });
  return el;
};

export function usePageMeta({ title, description, path, image, noindex = false, canonical = true, robots: robotsContent = 'noindex, follow' }) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      setTag('meta[name="description"]', { tag: 'meta', name: 'description', content: description });
      setTag('meta[property="og:description"]', { tag: 'meta', property: 'og:description', content: description });
      setTag('meta[name="twitter:description"]', { tag: 'meta', name: 'twitter:description', content: description });
    }
    if (title) {
      setTag('meta[property="og:title"]', { tag: 'meta', property: 'og:title', content: title });
      setTag('meta[name="twitter:title"]', { tag: 'meta', name: 'twitter:title', content: title });
    }

    const url = path && SITE_URL ? `${SITE_URL}${path === '/' ? '/' : path}` : null;
    if (!canonical) {
      document.head.querySelector('link[rel="canonical"]')?.remove();
      document.head.querySelector('meta[property="og:url"]')?.remove();
    } else if (url) {
      setTag('link[rel="canonical"]', { tag: 'link', rel: 'canonical', href: url });
      setTag('meta[property="og:url"]', { tag: 'meta', property: 'og:url', content: url });
    }
    if (SITE_URL) {
      const img = `${SITE_URL}${image || '/og-image.jpg'}`;
      setTag('meta[property="og:image"]', { tag: 'meta', property: 'og:image', content: img });
      setTag('meta[property="og:image:secure_url"]', { tag: 'meta', property: 'og:image:secure_url', content: img });
      setTag('meta[property="og:image:type"]', { tag: 'meta', property: 'og:image:type', content: 'image/jpeg' });
      setTag('meta[property="og:image:width"]', { tag: 'meta', property: 'og:image:width', content: '1200' });
      setTag('meta[property="og:image:height"]', { tag: 'meta', property: 'og:image:height', content: '630' });
      setTag('meta[property="og:image:alt"]', { tag: 'meta', property: 'og:image:alt', content: title || 'OVERALL WELLBEING' });
      setTag('meta[name="twitter:image"]', { tag: 'meta', name: 'twitter:image', content: img });
      setTag('meta[name="twitter:image:alt"]', { tag: 'meta', name: 'twitter:image:alt', content: title || 'OVERALL WELLBEING' });
    }

    const robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      setTag('meta[name="robots"]', { tag: 'meta', name: 'robots', content: robotsContent });
    } else if (robots) {
      robots.remove();
    }
  }, [title, description, path, image, noindex, canonical, robotsContent]);
}

export default usePageMeta;
